<div  style="min-height: 595px; position: relative; display: flex; align-content: center;justify-content: center;"  >
  <div class="page" style="font-family: OpenSansHebrewRegular">
<div class="top" style="display: flex; justify-content: center; position: relative;cursor: pointer;font-family: OpenSansHebrewRegular;">
<div class="note"  style="background-repeat: no-repeat; height: 200px; width: 1440px; align-self: center;" >
    <img class="img" [src]="Image"  style="height: 100% ;width: 100%;">
</div>
</div>

  <div  style="width: 100%; direction: rtl; margin-bottom: 20px;"  >
    <div class="order" style="direction: rtl;font-size: 14px; margin-right: 20px;">
      <div class="d-flex">
      <div class="align-self-lg-center" style="margin-left: 10px; font-size: 17px;" >ההזמנה שלך</div>
     <span class="name" style="position: absolute; left: 15%;">{{Name}}</span>
    </div>
    <img style="height: 1px; width: 95%; margin-left: 20px;" src="assets/images/Restorant_Page_Pay_Line.png">
      <div>
        <div *ngIf="IsDelivery"  class="d-flex delivery" style="width: 100%; margin-top: 10px; text-align: right;">
            <img src="assets/images/Order_Food_Icon_1.png">  
            <span class="col-9">משלוח</span> 
           <img class="align-self-center" style="cursor: pointer;" (click)="collectionFormClick(0)" [src]="checkBox==1 ? collectionFormCheckedOn :collectionFormCheckedOff">
           </div>
           <div *ngIf="isPickUp" class="d-flex pickUp" style="width: 100%; margin-top: 10px; text-align: right;">
            <img src="assets/images/Order_Food_Icon_2.png">  
            <span class="col-9">איסוף עצמי</span>
           <img class="align-self-center" style="cursor: pointer;" (click)="collectionFormClick(1)" [src]="checkBox==2 ? collectionFormCheckedOn :collectionFormCheckedOff">
           </div>
           <div *ngIf="IsSetting" class="d-flex pickUp" style="width: 100%; margin-top: 10px; text-align: right;">
            <img src="assets/images/Order_Food_Icon_3.png">  
            <span class="col-9">ישיבה במקום</span>
           <img class="align-self-center" style="cursor: pointer;" (click)="collectionFormClick(2)"  [src]="checkBox==3 ? collectionFormCheckedOn :collectionFormCheckedOff">
           </div>
          </div>
          <img style="height: 1px; width: 95%; margin-left: 20px;" src="assets/images/Restorant_Page_Pay_Line.png">
          </div>



          <app-popup-additionsSet
          isFromEdit=true
          [isOpen]="isPopupOpen"
          [dish]="selectedDish"
          (close)="closePopup()"
          (saveSet) = "saveSet()">
         </app-popup-additionsSet>
         

<div style="display: flex; flex-direction: row-reverse; ">
          <!-- מכאן מתחיל הויו הירוק -->
  <div *ngIf="orderList.length>0" class="container borderGreen" style="background-color: #29c066 ;color: white; height: auto; width: 320px; font-size: 14px;
  position: relative; border:none;  padding-bottom: 0px; margin-top: 28px;">
  <div class="container" style="margin-top: 5px;margin-bottom: 15px; height: 120px;
  width: 90%; color: #b7b7b7;
  background-color: white;">
  <div class="d-flex" style="direction: rtl;font-size: 14px;">
    <div>
      <div *ngIf="IsDelivery"  class="d-flex" style="width: 200px; margin-top: 10px; text-align: right;">
          <img src="assets/images/Order_Food_Icon_1.png">  
          <span class="col-8">משלוח</span> 
         <img class="align-self-center" style="cursor: pointer;" (click)="collectionFormClick(0)" [src]="checkBox==1 ? collectionFormCheckedOn :collectionFormCheckedOff">
         </div>
         <div *ngIf="isPickUp" class="d-flex" style="width: 200px; margin-top: 10px; text-align: right;">
          <img src="assets/images/Order_Food_Icon_2.png">  
          <span class="col-8">איסוף עצמי</span>
         <img class="align-self-center" style="cursor: pointer;" (click)="collectionFormClick(1)" [src]="checkBox==2 ? collectionFormCheckedOn :collectionFormCheckedOff">
         </div>
         <div *ngIf="IsSetting" class="d-flex" style="width: 200px; margin-top: 10px; text-align: right;">
          <img src="assets/images/Order_Food_Icon_3.png">  
          <span class="col-8">ישיבה במקום</span>
         <img class="align-self-center" style="cursor: pointer;" (click)="collectionFormClick(2)"  [src]="checkBox==3 ? collectionFormCheckedOn :collectionFormCheckedOff">
         </div>
        </div>
        </div>
  </div> 
<div class="d-flex " style="direction: rtl;">
    <div class="image0">
    <div style="text-align: right; margin-right: 7px;">
      <div class="align-self-lg-center" style="margin-left: 10px; font-size: 17px;" >ההזמנה שלך</div>
<img  style="margin-top: 10px; height: 1px; width: 95%;" src="assets/images/Pay_Line_1.png">
  </div> 
  <div *ngFor="let c of orderList ; let ind = index">
  <div class="d-flex" style="width: 200px; margin-top: 10px; text-align: right;font-size: 14px;">
 <span class="col-10" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{c.Name}}</span>
 <div class="col-3"></div>
 <div class="col-5">{{c.Price}} ₪</div>
</div> 
</div>
<div >
</div>
</div> 
</div>

<div class="d-flex m-auto" style="direction: rtl;
position: relative;">
<div class="align-self-lg-center" style="margin-right: 15px; margin-top: 25px;" >סה"כ פריטים</div>
<div style="direction: rtl; margin-top: 25px;" class="mr-lg-auto align-self-lg-center">
  <span> {{totalAmount}}</span>
</div>
</div>
<div *ngIf="priceDelivery>0 && checkBox==1" class="d-flex m-auto" style="direction: rtl;
position: relative;">
<div class="align-self-lg-center" style="margin-right: 15px;" >סה"כ משלוח</div>
<div style="direction: rtl;" class="mr-lg-auto align-self-lg-center">
  <span>{{priceDelivery}} ₪</span>
</div>
</div>
<div class="d-flex m-auto" style="direction: rtl; font-weight: bold; position: relative;">
<div  (click)="payment()" class="align-self-lg-center cart" style="cursor: pointer;">
  <img src="assets/images/Restorant_Page_Pay_Button.png">               
  <span class="centered" style="width: 100%;">המשך לתשלום</span>
</div>
<div style="direction: rtl;" class="mr-lg-auto align-self-lg-center">
  <span>סה"כ {{allPrice}} ₪</span>
</div>
</div>
<div  (click)="navigateToRestaurant()" class="navDiv" >
           
  <span  style="width: 100%;">חזרה לתפריט המסעדה</span>
</div>
</div>
<!-- 
כאן נגמר הויו -->
 <!-- <div  class="centered" style="background-color: #29c066 ;color: white; height: auto; width: 320px; font-size: 14px;> -->

<div *ngIf="showProgress==true" style="display: flex; justify-content: center; align-items: center; position: fixed; inset: 0; z-index: 9999; ">
  <mat-spinner class="mat-spinner-color" [diameter]="70" mode="indeterminate"></mat-spinner>
</div>
<!-- כאן מתחיל הפור -->
<div class="d-flex flex-wrap col-lg-offset-3 note" style="justify-self:right; margin-top: 10px;  direction: rtl; width: calc(1440px - 320px); "  >

  <div *ngFor="let o of orderList; let i = index" class="delivery" >
    <!-- <div class="border" style="margin-top: 20px;
    height: auto; width: 340px; color: #979797;font-size: 14px;" [appResponsiveWidth] = "340" [minWidth] = "330" > -->
    <div class="note-redesign">
      <div class="note-header">
        <div class="note-reight">
  <div class="note-title">
    <span class="note-item-name">{{o.Name}}</span>
    <span *ngIf="o.InviteName!=null&& o.InviteName!=''" class="note-customer-name"><small>#</small>{{(o.InviteName)}}</span>
         <span *ngIf="o.Comments!=null&& o.Comments!=''" class="note-customer-name note-name"><small>#</small>{{(o.Comments)}}</span>
  </div>
  
    </div>
  <div class="note-image">
    <img class="imgRedesign" [src]="o.BigImgFile"  style="height: 100% ;width: 100%; border-radius: 6px; ">
  </div>
</div>
<div class="note-details">
    <span class="note-price">{{o.Price}} ₪</span>
    <div class="note-actions">
     <button class="note-btn note-btn-eddit" (click)="editItem(o,o.MenuNumber,i)">
        <svg class="note-svg" viewBox="0 0 55 53" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M32.9152 49.81H51.2009M3.6582 49.81L16.9641 47.129C17.6704 46.9866 18.319 46.6388 18.8284 46.1292L48.6148 16.3264C50.0429 14.8975 50.042 12.5813 48.6127 11.1536L42.3028 4.85094C40.8741 3.42384 38.5591 3.42481 37.1316 4.85311L7.34205 34.659C6.83367 35.1676 6.48654 35.8149 6.34408 36.5198L3.6582 49.81Z" stroke="#A8A6AC" stroke-width="6.09524" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>

      <button class="note-btn" (click)="setDuplicateMenu(o)" >
    <svg class="plus-close-svg" viewBox="0 0 69 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.428711" y="0.507812" width="68.5714" height="68.5714" rx="34.2857" fill="#29BF65" fill-opacity="0.2"/>
      <path d="M49.5713 34.793L18.7141 34.793" stroke="#29BF65" stroke-width="5.71429" stroke-linecap="round"/>
      <path d="M33.5713 50.793L33.5713 19.9358" stroke="#29BF65" stroke-width="5.71429" stroke-linecap="round"/>
    </svg>
    
  </button>
  <button class="note-btn" (click)="delete(o)">
    <svg class="plus-close-svg" viewBox="0 0 69 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="0.507812" width="68.5714" height="68.5714" rx="34.2857" fill="#F15A5A" fill-opacity="0.28"/>
      <path d="M45.0293 45.8711L23.21 24.0518" stroke="#F15A5A" stroke-width="5.71429" stroke-linecap="round"/>
      <path d="M22.4004 45.8711L44.2197 24.0518" stroke="#F15A5A" stroke-width="5.71429" stroke-linecap="round"/>
    </svg>
  </button>
    </div>
  
  
  </div>
  <div class="note-divider"></div>

<div class="listSets">


      <!-- Original set ingredients -->
   
        <div *ngFor="let m of o.listSets" class="listSet">
          <div id="28" *ngIf="!m.Ingredients[0].DealOrderMenu" class="setName">{{m.SetName}}</div>
          
          <!-- Main ingredients and their internal sets -->
         <div  *ngFor="let i of m.Ingredients" style="width: 100%;">
          <app-ingredient-set [ingredient]="i"></app-ingredient-set>
  

          </div>
      
      
      </div>
</div>

</div>
</div>
  </div>
  <!-- כאן נגמר הפור -->
   </div>

<div class="note" style="display: flex; width: 50%; margin-right: 3.5%; background-color: #FFFFFF;">
<div class="noteIcon" style="right: 14%; position: absolute; margin-top: 20px;
direction: rtl; color: #9b9b9b; text-align: right;">
<img src="assets/images/Order_Food_Edit_Icon.png">
<span style="margin-right: 5px; font-size: 14px;">הערות למשלוח</span>
</div>
  <textarea (focusout)="onFocusOutEvent($event)" (blur)='onBlur()' class="container noteInput" style="margin-bottom: 20px; margin-top: 45px; min-height: 120px; width: 60%; color: gray; overflow: hidden;
  text-align: right; direction: inherit; font-weight: 100; font-size: 15px; max-lines: 4;" type="text" maxlength="40"
  required name="note" mdInput [(ngModel)]="note" rows="4" (input)="limitLines($event, 4)"></textarea> 
</div>
</div>
</div>